"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _direction = _interopRequireDefault(require("../../../shapes/direction.shape"));

class MenuButton extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "state", {
      menuClassName: ''
    });
    (0, _defineProperty2.default)(this, "onDocumentClick", e => {
      const {
        onClose,
        showMenu
      } = this.props;

      if (!showMenu) {
        return;
      }

      if (!e.target.closest(".".concat(this.getUniqueClassName()))) {
        onClose();
      }
    });
    (0, _defineProperty2.default)(this, "onClick", e => {
      e.stopPropagation();
      const {
        onClick
      } = this.props;
      onClick(e);
      MenuButton.zIndex++;
      this.setState({
        zIndex: MenuButton.zIndex
      });
    });
    MenuButton.uId++;
    this.uId = MenuButton.uId;
  }

  componentDidMount() {
    document.addEventListener('click', this.onDocumentClick);
    this.setState({
      menuClassName: this.getUniqueClassName(),
      zIndex: MenuButton.zIndex
    });
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  getUniqueClassName() {
    return "menu-button-".concat(this.uId);
  }

  render() {
    const {
      children,
      className,
      showMenu,
      menuDirection
    } = this.props;
    const {
      menuClassName,
      zIndex
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('menu-button', className, menuClassName, {
        'menu-button--highlight': showMenu
      }),
      onClick: this.onClick,
      style: {
        zIndex
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-button__icon"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('menu-button__menu', {
        'menu-button__menu--hidden': !showMenu,
        'menu-button__menu--right': menuDirection === 'right',
        'menu-button__menu--left': menuDirection === 'left'
      })
    }, children));
  }

}

(0, _defineProperty2.default)(MenuButton, "propTypes", {
  children: _propTypes.default.node,
  onClick: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  showMenu: _propTypes.default.bool,
  onClose: _propTypes.default.func.isRequired,
  menuDirection: _direction.default
});
(0, _defineProperty2.default)(MenuButton, "defaultProps", {
  children: null,
  className: '',
  showMenu: false,
  menuDirection: 'right'
});
(0, _defineProperty2.default)(MenuButton, "uId", 0);
(0, _defineProperty2.default)(MenuButton, "zIndex", 1);
var _default = MenuButton;
exports.default = _default;